import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { EventCheckinModalPage } from './event-checkin-modal.page';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
  ],
  declarations: [EventCheckinModalPage],
})
export class EventCheckinModalModule {
}
